import {connect} from 'react-redux';
import * as React from "react";
import * as selectors from "../selectors";
import {EventlogState, Event} from "../EventlogState";

interface ComponentState {
}

interface TagProps {
}

interface StateProps {
    fetchingEvents: boolean,
    filteredEvents: Event[],
}

interface DispatchProps {
}

const mapStateToProps = (state: EventlogState): StateProps => {
    return {
        fetchingEvents: selectors.fetchingEvents(state),
        filteredEvents: selectors.getFilteredEvents(state),
    }
};

const mapDispatchToProps: DispatchProps = ({
});

type Props = TagProps & StateProps & DispatchProps;

class Events extends React.Component<Props, ComponentState> {

    render() {

        let {
            fetchingEvents,
            filteredEvents,
        } = this.props;

        if (fetchingEvents) {
            return (<div className="datafangst-loading"/>);
        }

        return (
            <div className={"events"}>
                <table className="table table-hover">
                    <thead>
                    <tr>
                        <th style={{width: "5%"}} scope="col">Tidspunkt</th>
                        <th style={{width: "5%"}} scope="col">Bruker</th>
                        <th style={{width: "5%"}} scope="col">Handling</th>
                        <th style={{width: "5%"}} scope="col">Objekttype</th>
                        <th style={{width: "10%"}} scope="col">Objekt</th>
                        <th style={{width: "15%"}} scope="col">Merknad</th>
                    </tr>
                    </thead>
                    <tbody>
                    {filteredEvents
                        .map((event: Event ) => {
                            return (
                                <tr key={event.id}>
                                    <td>{event.occurredInstant.toLocaleString()}</td>
                                    <td>{event.userId}</td>
                                    <td>{event.eventType}</td>
                                    <td>{event.objectType}</td>
                                    <td>{event.object}</td>
                                    <td>{event.data}</td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>
        );
    }
}
export const ContractEvents = connect(mapStateToProps, mapDispatchToProps)(Events);